module.exports = __webpack_public_path__ + "img/comment.666e7e9f.svg";